import URL from "core/resources/urls";
import http from "infra/http";
import { useMutation } from "react-query";

export interface CreateGroupsJobsRequest {
  nome: string;
  ativo: boolean;
  jobIds: string[];
}

export default function useCreateGroupsJobs() {
  return useMutation({
    mutationFn: async (data: CreateGroupsJobsRequest) => {
      const response = await http.post(URL.RECURRING_JOB_GROUP.CRIAR(), data);
      return response.data;
    },
  });
}
